module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home"
  }, [_c('div', {
    staticClass: "weui-fp weui-fpbj"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fpnr"
  }, [_c('p', [_c('label', [_vm._v("发票代码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoiceCode))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("发票号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.invoiceNum))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("开票日期")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.date))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("不含税金额")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "sczp"
  }, [_c('label', {
    staticClass: "weui_label"
  }, [_vm._v("上传照片")]), _vm._v(" "), _c('p', [_c('span', [_c('img', {
    attrs: {
      "slot": "icon",
      "width": "57px",
      "height": "57",
      "src": require("../../assets/img/img_add.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "slot": "icon",
      "width": "57px",
      "height": "57",
      "src": require("../../assets/img/fp3.jpg")
    },
    slot: "icon"
  }), _c('sup', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "5px",
      "z-index": "101"
    }
  }, [_c('font', {
    staticClass: "vux-badge vux-badge-single"
  }, [_vm._v("X")])], 1)]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "slot": "icon",
      "width": "57px",
      "height": "57",
      "src": require("../../assets/img/fp3.jpg")
    },
    slot: "icon"
  }), _c('sup', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "5px",
      "z-index": "101"
    }
  }, [_c('font', {
    staticClass: "vux-badge vux-badge-single"
  }, [_vm._v("X")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/dzfppz/')
      }
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/fp2.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc6f2e12"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/scdzfp.vue
// module id = 352
// module chunks = 0